import {TSignDialogState} from "./types";

export const initialState: TSignDialogState = {
    tab: 'draw',
    sign: '',
    insertEverywhere: false,
    file: null,
    fileName: null
}